export default __webpack_public_path__ + "static/media/photo-owner-1__2x.2ab6a5c5.png";